/**
 * @generated SignedSource<<ad8813de4aaac9b8e92e92b4899930ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type groupContextMenu_QueryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"inviteMemberModal_QueryFragment">;
  readonly " $fragmentType": "groupContextMenu_QueryFragment";
};
export type groupContextMenu_QueryFragment$key = {
  readonly " $data"?: groupContextMenu_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupContextMenu_QueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./groupContextMenuRefetchQuery.graphql')
    }
  },
  "name": "groupContextMenu_QueryFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "inviteMemberModal_QueryFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "83750b9ef9ac72f598b3ac9e61bcdd87";

export default node;
